enum OrderUrlActions {
  JUST_TODAY = "just_today",
  ANOTHER_DAY = "another_day",
  CHECK_AVAILABILITY = "check_availability",
}

export default OrderUrlActions;